import { Divider, pxToRem } from "@getbread/dough";
import { styled } from "@mui/material/styles";
import { FormattedMessage, useIntl } from "react-intl";
import { getConfig } from "../../utils/getConfig";
import { useConfirmLanguageChange } from "../ConfirmLanguageChange";
import { LocaleDropdown } from "../LocaleDropdown/LocaleDropdown";
import { useLocale } from "../LocaleProvider";
import { HeaderExteriorLink, HeaderLink } from "./HeaderLink";

// Last nav link had too much space from the right edge of the screen
const DesktopLink = styled(HeaderLink)`
	margin-right: ${pxToRem(8)};
	margin-left: ${pxToRem(8)};
	font-size: ${pxToRem(16)};
`;

const DesktopLinkExternal = styled(HeaderExteriorLink)`
	margin: 0 var(--space-s);
	font-size: ${pxToRem(16)};
`;

const LocaleContainer = styled("div")`
	display: inline-flex;
	width: ${pxToRem(50)};
	margin-left: var(--space-s);
`;

const Nav = styled("nav")`
	display: flex;

	ul {
		list-style-type: none;
		display: flex;
		margin-top: ${pxToRem(8)};
		margin-bottom: ${pxToRem(8)};
	}
`;

const DesktopNav: React.FC = () => {
	const [openLanguageChange, LanguageChangeModal] = useConfirmLanguageChange();
	const { locale } = useLocale();
	const intl = useIntl();
	const faqLinks = getConfig("faqlinks").general;
	const faqLink = faqLinks[locale];

	const hasMultipleLanguages = getConfig("locales").length > 1;

	return (
		<Nav
			aria-label={intl.formatMessage({
				defaultMessage: "Member Portal Navigation",
			})}
		>
			{LanguageChangeModal}
			<ul>
				<li>
					<DesktopLink to="/loans" data-testid="desktop-loans-link">
						<FormattedMessage defaultMessage="Loans" />
					</DesktopLink>
				</li>
				<li>
					<DesktopLink to="/my-information" data-testid="desktop-account-link">
						<FormattedMessage defaultMessage="My Information" />
					</DesktopLink>
				</li>
				<li>
					<DesktopLink to="/loan-documents" data-testid="desktop-loan-documents-link">
						<FormattedMessage defaultMessage="Loan Documents" />
					</DesktopLink>
				</li>
				<li>
					<DesktopLinkExternal
						href={faqLink}
						target="_blank"
						rel="noopener"
						data-testid="desktop-faqs-link"
					>
						<FormattedMessage defaultMessage="FAQs" />
					</DesktopLinkExternal>
				</li>
				<li>
					<DesktopLink to="/logout" data-testid="desktop-sign-out-link">
						<FormattedMessage defaultMessage="Sign Out" />
					</DesktopLink>
				</li>
			</ul>
			{hasMultipleLanguages && (
				<>
					<Divider orientation="vertical" />
					<LocaleContainer>
						<LocaleDropdown
							selected={locale}
							selectLocale={(newLocale) => {
								openLanguageChange(newLocale);
							}}
						/>
					</LocaleContainer>
				</>
			)}
		</Nav>
	);
};

export { DesktopNav };
